<template lang="pug">
.base-info-block-listagem.px-2(v-if='!valorMoeda')
    .base-info-block-listagem-box.px-2(
        v-for='(titulo, idx) in titulosInfoBlock',
        :style='titulosInfoBlock.length > 2 ? "margin-right: 40px;" : "margin-right: 100px;"'
    )
        .base-info-block-box-texto
            | {{ titulosInfoBlock[idx] }}
        .base-info-block-box-value
            | {{ valorIsArray(valoresInfoBlock[idx]) || '- -' }}
            span(v-if='unidadeMedida') &nbsp;{{ unidadeMedida }}
.base-info-block-listagem.px-2(v-else)
    .base-info-block-listagem-box.px-2(
        v-for='(titulo, idx) in titulosInfoBlock',
        :style='titulosInfoBlock.length > 2 ? "margin-right: 40px;" : "margin-right: 100px;"'
    )
        .base-info-block-box-texto
            | {{ titulosInfoBlock[idx] }}
        .base-info-block-box-value
            | {{ addCurrencySymbol(valoresInfoBlock[idx]) || '- -' }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'BaseInfoBlock',

    props: {
        titulosInfoBlock: {
            type: Array,
            required: true,
            default: () => []
        },
        valoresInfoBlock: {
            type: Array,
            required: true,
            default: () => []
        },
        unidadeMedida: {
            type: String,
            default: ''
        },
        valorMoeda: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        valorIsArray(titulo) {
            if (Array.isArray(titulo)) {
                return titulo.join(', ');
            }
            return titulo;
        },
        addCurrencySymbol(text) {
            if (!text) {
                return '- -';
            }

            if (text.startsWith('DE')) {
                const formattedText = text.replace('DE', '');

                const [firstNumber, secondNumber] = formattedText
                    .trim()
                    .split('A');

                const formattedFirstNumber = parseFloat(
                    firstNumber.replace('.', '').replace(',', '.')
                ).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });

                const formattedSecondNumber = parseFloat(
                    secondNumber.replace('.', '').replace(',', '.')
                ).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });

                return `${this.$t(
                    'mensagens.preAnaliseCredito.prefixos.de'
                )} ${formattedFirstNumber} ${this.$t(
                    'mensagens.preAnaliseCredito.prefixos.a'
                )} ${formattedSecondNumber}`;
            } else if (text.startsWith('ACIMA DE')) {
                const formattedText = text.replace('ACIMA DE', '');

                const formattedNumber = parseFloat(
                    formattedText.replace('.', '').replace(',', '.')
                ).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });

                return `${this.$t(
                    'mensagens.preAnaliseCredito.prefixos.acimaDe'
                )} ${formattedNumber}`;
            } else if (text.startsWith('ATE')) {
                const formattedText = text.replace('ATE', '');

                const formattedNumber = parseFloat(
                    formattedText.replace('.', '').replace(',', '.')
                ).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });

                return `${this.$t(
                    'mensagens.preAnaliseCredito.prefixos.ate'
                )} ${formattedNumber}`;
            }

            return this.formatNumber(text[0]);
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        }
    }
};
</script>

<style lang="scss">
.base-info-block-listagem {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 15px;
    margin-bottom: 15px;

    .base-info-block-listagem-box {
        display: flex;
        flex-direction: column;
        max-width: auto;
        min-width: 300px;

        .base-info-block-box-texto {
            font-weight: 500;
            color: #3b3b3b;
            line-height: 16px;
            font-size: 14px;
            margin-bottom: 10px;
        }
        .base-info-block-box-value {
            font-weight: 400;
            color: #3b3b3b;
            line-height: 16px;
            font-size: 14px;
            max-width: 230px;
        }
    }
}
</style>
